import React from 'react';
import { Note } from '~/components/Patient';

interface ReminderAuditNotesProps {
    notes: NoteType[];
    patientId: number;
}

export function ReminderAuditNotes({ notes, patientId }: ReminderAuditNotesProps) {
    function getPreviousAuditNote(index: number) {
        // Some types of audit notes won't have the previous reminder metadata,
        // so find the next one that does.
        return notes.slice(index + 1).find((x) => x.metadata?.due_at) || notes[notes.length - 1];
    }

    return (
        <div className="note-scroll">
            {notes
                // action of null is a user note, so omit from the audit notes
                .filter((note) => note.action !== null)
                .map((x, i) => (
                    <Note
                        key={x.id}
                        entityId={patientId}
                        note={x}
                        previousNote={getPreviousAuditNote(i)}
                        enableOpenModal
                    />
                ))}
        </div>
    );
}
